const httpUrl = {
  // baseUrl: 'http://192.168.0.130:10002',
  // baseUrl: 'https://yuanshanqeh.jm688.top/prod-api',
  baseUrl: 'https://openapi.farhilltour.com/prod-api',
}
export default httpUrl
